import { Styles } from 'assets/types';

const stripeFormStyles: Styles = () => ({});

export default stripeFormStyles;
